<template>
  <v-dialog v-model="dialog" width="500">
    <v-btn
      id="add_documentary_instruction"
      depressed
      flat
      slot="activator"
      color="primary"
      small
      ><v-icon small class="pr-2"> {{ iconTitle() }} </v-icon
      >{{ buttonTitle() }}</v-btn
    >

    <v-card tile flat>
      <v-toolbar tile card flat dense color="theme_primary" class="white--text">
        <v-spacer></v-spacer>
        <v-toolbar-title class="white-text text-capitalize"
          >Documentary Instructions</v-toolbar-title
        >

        <v-spacer></v-spacer>
        <v-toolbar-side-icon>
          <v-icon color="white">assignment</v-icon>
        </v-toolbar-side-icon>
      </v-toolbar>

      <v-card-text>
        <v-text-field
          id="documentary-instruction-name"
          v-model="documentaryInstructions.name"
          required
          label="Name"
          background-color="white"
          box
        />

        <uploader
          name="exp-12"
          v-on:s3url="updateDocumentaryInstructionUrl($event)"
        />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="save-documentary-instruction"
          small
          @click="save"
          flat
          color="success"
          >Save</v-btn
        >
        <v-btn @click="dialog = false" small flat color="error">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CREATE_DOCUMENTARY_INSTRUCTION from "../../graphql/documentary_instructions/create.gql";
import UPDATE_DOCUMENTARY_INSTRUCTION from "../../graphql/documentary_instructions/update.gql";
import { mapGetters } from "vuex";
import uploader from "../shared/uploader";

export default {
  components: {
    uploader,
  },
  props: {
    objectId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
      documentaryInstructions: {},
    };
  },
  methods: {
    buttonTitle() {
      return this.objectId ? "Update" : "New Documentary Instructions";
    },
    iconTitle() {
      return this.objectId ? "refresh" : "add";
    },
    updateDocumentaryInstructionUrl(url) {
      this.documentaryInstructions.document_url = url;
    },
    save() {
      this.dialog = false;
      this.documentaryInstructions.customer_id = this.newCompany.customer.id;
      this.documentaryInstructions.company_id = this.$route.params.id;
      const name =
        "documentary instruction " + this.documentaryInstructions.name;
      if (this.objectId) {
        this.sendMutation(
          "updated",
          name,
          UPDATE_DOCUMENTARY_INSTRUCTION,
          this.documentaryInstructions
        );
      } else {
        this.sendMutation(
          "created",
          name,
          CREATE_DOCUMENTARY_INSTRUCTION,
          this.documentaryInstructions
        ).then(() => {
          this.documentaryInstructions = {};
        });
      }
    },
  },
  computed: {
    ...mapGetters("companyStore", ["newCompany", "getDocumentaryInstruction"]),
  },
  mounted() {
    if (this.objectId) {
      this.documentaryInstructions = this.getDocumentaryInstruction(
        this.objectId
      );
    }
  },
};
</script>
